import React, { useState } from 'react';
import { PostgreSQLModalContent } from './PostgreSQLModal/postgreSQLModalContent';
import { getTables, readTable } from './PostgreSQLModal/tables';
import DynamicModal from '../../Modal/DynamicModal';
import { PostgreSQLTableModalContent } from '../../PostgreSqlTableModaContent/PostgreSQLTableModalContent';
import Accordion from 'react-bootstrap/Accordion';
import { toast } from "react-toastify";
import { GeoJsonLayer } from '@deck.gl/layers';
import bbox from '@turf/bbox';
import proj4 from 'proj4';
import './AddLayerSidebar.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { showMapConfirmToast } from "../../../utils/Toast/mapToast";

proj4.defs(
  'EPSG:3908',
  '+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=6500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs +type=crs'
);

proj4.defs(
  'EPSG:8678',
  '+proj=tmerc +lat_0=0 +lon_0=18 +k=0.9999 +x_0=6500000 +y_0=0 +ellps=bessel +towgs84=682,-203,480,0,0,0,0 +units=m +no_defs +type=crs'
);

const AddLayerSidebar = ({
  handleLayerSubmit,
  handleWmsLayerSubmit,
  handleLoadGML,
  handleLoadKML,
  handleLoadGeoJson,
  handleLoadDXF,
  handleLoadShapefile,
  handleLoadLasFile,
  setOverlay,
  setWfsLayers,
  setHoverInfo,
  setViewState
}) => {
  const [wfsUrl, setWfsUrl] = useState('');
  const [wmsBaseUrl, setWmsBaseUrl] = useState('');
  const [wmsLayerName, setWmsLayerName] = useState('');

  const [isPostgresqlModalVisible, setIsPostgresqlModalVisible] = useState(false);
  const [isPostgreSQLTableModalOpen, setIsPostgreSQLTableModalOpen] = useState(false);

  const [host, setHost] = useState('');
  const [port, setPort] = useState('');
  const [database, setDatabase] = useState('');
  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');

  const [postgreSQLTables, setPostgreSQLTables] = useState(null);
  const [clickedTable, setClickedTable] = useState('');
  const [isLoadingPostgreSQLTables, setIsLoadingPostgreSQLTables] = useState(false);
  const [lasFileCrs, setLasFileCrs] = useState("EPSG:4326");
  const [formActiveKey, setFormActiveKey] = useState(null);

  const handleSubmitWfs = () => {
    if (!wfsUrl.trim()) {
      toast.warning("Unesite WFS URL.");
      return;
    }

    handleLayerSubmit(wfsUrl.trim());
    setWfsUrl('');
  };

  const handleSubmitWms = () => {
    if (!wmsBaseUrl.trim() || !wmsLayerName.trim()) {
      toast.warning("Unesite WMS osnovni URL i naziv sloja.");
      return;
    }

    handleWmsLayerSubmit(wmsBaseUrl.trim(), wmsLayerName.trim());
    setWmsBaseUrl('');
    setWmsLayerName('');
  };

  const openPostgreSQLModal = () => {
    setIsPostgresqlModalVisible(true);
  };

  const closePostgreSQLModal = () => {
    setIsPostgresqlModalVisible(false);
  };

  const closePostgreSQLTableModal = () => {
    setIsPostgreSQLTableModalOpen(false);
  };

  const transformCoords = (coordinates, fromSrid) => {
    if (!proj4.defs[`EPSG:${fromSrid}`]) return coordinates;

    const transform = (coord) => proj4(`EPSG:${fromSrid}`, 'EPSG:4326', coord);

    if (typeof coordinates[0] === 'number') {
      return transform(coordinates);
    }

    return coordinates.map(c => transformCoords(c, fromSrid));
  };

  const hexToBytes = (hex) =>
    new Uint8Array(hex.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));

  const parseWKB = (hex) => {
    const buffer = hexToBytes(hex);
    const view = new DataView(buffer.buffer);

    const byteOrder = view.getUint8(0);
    const le = byteOrder === 1;
    const rawType = view.getUint32(1, le);
    const hasSRID = (rawType & 0x20000000) !== 0;
    const type = rawType & 0xFFFF;

    let offset = 5;

    if (hasSRID) offset += 4;

    if (type === 1) {
      const x = view.getFloat64(offset, le);
      const y = view.getFloat64(offset + 8, le);

      return {
        type: 'Point',
        coordinates: [x, y]
      };
    }

    if (type === 2) {
      const numPoints = view.getUint32(offset, le);
      offset += 4;

      const coords = [];

      for (let i = 0; i < numPoints; i++) {
        const x = view.getFloat64(offset, le);
        const y = view.getFloat64(offset + 8, le);

        coords.push([x, y]);
        offset += 16;
      }

      return {
        type: 'LineString',
        coordinates: coords
      };
    }

    if (type === 3) {
      const numRings = view.getUint32(offset, le);
      offset += 4;

      const rings = [];

      for (let i = 0; i < numRings; i++) {
        const numPoints = view.getUint32(offset, le);
        offset += 4;

        const ring = [];

        for (let j = 0; j < numPoints; j++) {
          const x = view.getFloat64(offset, le);
          const y = view.getFloat64(offset + 8, le);

          ring.push([x, y]);
          offset += 16;
        }

        rings.push(ring);
      }

      return {
        type: 'Polygon',
        coordinates: rings
      };
    }

    throw new Error(`Nepodržan geometrijski tip: ${rawType}`);
  };

  const handleOpenPostgreSQLTable = async (table) => {
    if (setOverlay) {
      setOverlay({
        active: true,
        message: `Provjera sadržaja tabele ${table}...`
      });
    }

    const content = await readTable(host, port, database, user, password, table);

    if (setOverlay) {
      setOverlay({ active: false });
    }

    if (!content || !content.columns) {
      toast.error("Greška pri učitavanju sadržaja tabele.");
      return;
    }

    const geometryCol = content.columns.find((col) => {
      const type = col.data_type?.toLowerCase();
      const udt = col.udt_name?.toLowerCase();

      return type === 'geometry' || udt === 'geometry';
    });

    if (!geometryCol) {
      setClickedTable(table);
      setIsPostgreSQLTableModalOpen(true);
      return;
    }

    if (typeof setWfsLayers !== 'function') {
      toast.error("Dodavanje sloja nije dostupno.");
      return;
    }

    const srid = content?.srid ?? 4326;

    const features = content.data
      .map((row, index) => {
        const geomData = row[geometryCol.column_name];

        if (!geomData || typeof geomData !== 'string' || !/^[0-9A-Fa-f]+$/.test(geomData.trim())) {
          return null;
        }

        try {
          const geometry = parseWKB(geomData);

          const transformed = {
            ...geometry,
            coordinates: transformCoords(geometry.coordinates, srid)
          };

          return {
            type: 'Feature',
            geometry: transformed,
            properties: {
              ...row,
              [geometryCol.column_name]: undefined
            },
            id: `${table}-${index}`
          };
        } catch (err) {
          console.warn(`Greška u parsiranju za red ${index}:`, err);
          return null;
        }
      })
      .filter(Boolean);

    if (features.length === 0) {
      toast.warning("Tabela ima geometrijsku kolonu, ali nema validnih geometrija za prikaz.");
      return;
    }

    const featureCollection = {
      type: 'FeatureCollection',
      features
    };

    const layer = new GeoJsonLayer({
      id: `pgsql-layer-${table}`,
      data: featureCollection,
      source: "catalog",
      pickable: true,
      stroked: true,
      filled: true,
      getFillColor: [100, 150, 250, 160],
      getLineColor: [0, 0, 0, 255],
      getRadius: 5,
      pointRadiusMinPixels: 4,
      lineWidthMinPixels: 1,
      onHover: (info) => setHoverInfo(info),
    });

    setWfsLayers(prev => [
      ...prev.filter(l => l.id !== `pgsql-layer-${table}`),
      layer
    ]);

    if (typeof setViewState === 'function') {
      const [minX, minY, maxX, maxY] = bbox(featureCollection);

      const centerLon = (minX + maxX) / 2;
      const centerLat = (minY + maxY) / 2;
      const lonRange = maxX - minX;
      const latRange = maxY - minY;
      const zoom = Math.log2(360 / Math.max(lonRange, latRange));

      showMapConfirmToast({
        title: "Pozicioniranje mape",
        message: "Da li želite da se prikaz mape pozicionira prema sloju iz PostgreSQL baze?",
        confirmText: "Da",
        cancelText: "Ne",
        variant: "info",
        onConfirm: () => {
          setViewState(prev => ({
            ...prev,
            longitude: centerLon,
            latitude: centerLat,
            zoom,
            pitch: 0,
            bearing: 0,
            transitionDuration: 1000,
          }));
        },
      });
    }
  };

  const readPostgreSQL = async () => {
    if (!host.trim() || !port.trim() || !database.trim() || !user.trim()) {
      toast.warning("Popunite osnovne podatke za PostgreSQL konekciju.");
      return;
    }

    if (setOverlay) {
      setOverlay({
        active: true,
        message: `Dohvatanje liste tabela iz baze ${database}...`
      });
    }

    setIsLoadingPostgreSQLTables(true);

    const tables = await getTables(host, port, database, user, password);

    if (setOverlay) {
      setOverlay({ active: false });
    }

    if (tables === null) {
      setIsLoadingPostgreSQLTables(false);
      toast.error("Došlo je do greške. Provjerite kredencijale!");
      return;
    }

    setPostgreSQLTables(
      <div key="postgresql-tables" className="postgresql-tables-list">
        {tables?.map((table, index) => (
          <div
            key={index}
            className="postgresql-table-item"
            onClick={() => handleOpenPostgreSQLTable(table)}
          >
            {table}
          </div>
        ))}
      </div>
    );

    setIsLoadingPostgreSQLTables(false);
  };

  return (
    <>
      <div className="form-accordion">
        <h6>Dodavanje sloja</h6>

        <Accordion
          activeKey={formActiveKey}
          onSelect={(key) => setFormActiveKey(key === formActiveKey ? null : key)}
        >
          <Accordion.Item eventKey="0">
            <Accordion.Header>DBMS</Accordion.Header>

            <Accordion.Body>
              <div className="centered-button-wrapper">
                <button onClick={openPostgreSQLModal}>
                  PostgreSQL
                </button>
              </div>

              {isLoadingPostgreSQLTables && (
                <label>Učitavam tabele...</label>
              )}

              {postgreSQLTables}

              {postgreSQLTables && (
                <div className="disconnect-wrapper">
                  <button
                    className="disconnect-btn"
                    onClick={() => setPostgreSQLTables(null)}
                  >
                    Prekini konekciju
                  </button>
                </div>
              )}
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>GIS fajlovi</Accordion.Header>

            <Accordion.Body>
              <div className="centered-xml-wrapper">
                <div className="inputBtn">
                  <label htmlFor="gmlInput" className="external-button-label-style">
                    Učitaj GML
                  </label>

                  <input
                    id="gmlInput"
                    type="file"
                    accept=".xml, .gml"
                    style={{ display: 'none' }}
                    onChange={(e) => e.target.files[0] && handleLoadGML(e.target.files[0])}
                  />
                </div>

                <div className="inputBtn">
                  <label htmlFor="kmlInput" className="external-button-label-style">
                    Učitaj KML
                  </label>

                  <input
                    id="kmlInput"
                    type="file"
                    accept=".kml"
                    style={{ display: 'none' }}
                    onChange={(e) => e.target.files[0] && handleLoadKML(e.target.files[0])}
                  />
                </div>

                <div className="inputBtn">
                  <label htmlFor="geojsonInput" className="external-button-label-style">
                    Učitaj GeoJSON
                  </label>

                  <input
                    id="geojsonInput"
                    type="file"
                    accept=".geojson, .json"
                    style={{ display: 'none' }}
                    onChange={(e) => e.target.files[0] && handleLoadGeoJson(e.target.files[0])}
                  />
                </div>

                <div className="inputBtn">
                  <label htmlFor="shapefileInput" className="external-button-label-style">
                    Učitaj Shapefile
                  </label>

                  <input
                    id="shapefileInput"
                    type="file"
                    accept=".zip"
                    style={{ display: 'none' }}
                    onChange={(e) => e.target.files[0] && handleLoadShapefile(e.target.files[0])}
                  />
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>AutoCAD</Accordion.Header>

            <Accordion.Body>
              <div className="centered-dxf-wrapper">
                <label htmlFor="dxfInput" className="external-button-label-style">
                  Učitaj DXF
                </label>

                <input
                  id="dxfInput"
                  type="file"
                  accept=".dxf"
                  style={{ display: 'none' }}
                  onChange={(e) => e.target.files[0] && handleLoadDXF(e.target.files[0])}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>OGC Geoservisi</Accordion.Header>

            <Accordion.Body>
              <div className="ogc-wrapper">
                <input
                  type="text"
                  value={wfsUrl}
                  onChange={(e) => setWfsUrl(e.target.value)}
                  placeholder="WFS URL"
                  title="WFS URL"
                  required
                />

                <button onClick={handleSubmitWfs}>
                  Dodaj WFS
                </button>

                <input
                  type="text"
                  value={wmsBaseUrl}
                  onChange={(e) => setWmsBaseUrl(e.target.value)}
                  placeholder="WMS osnovni URL"
                  title="WMS osnovni URL"
                />

                <input
                  type="text"
                  value={wmsLayerName}
                  onChange={(e) => setWmsLayerName(e.target.value)}
                  placeholder="Naziv sloja, npr. elektro:stubovi"
                  title="Naziv sloja"
                />

                <button onClick={handleSubmitWms}>
                  Dodaj WMS
                </button>
              </div>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>Učitaj oblak tačaka</Accordion.Header>

            <Accordion.Body>
              <div className="centered-las-wrapper">
                <select
                  value={lasFileCrs}
                  onChange={(e) => setLasFileCrs(e.target.value)}
                >
                  <option value="EPSG:4326">EPSG:4326</option>
                  <option value="EPSG:3908">EPSG:3908</option>
                  <option value="EPSG:8678">EPSG:8678</option>
                </select>

                <label htmlFor="lasInput" className="external-button-label-style">
                  Učitaj LAS
                </label>

                <input
                  id="lasInput"
                  type="file"
                  accept=".las"
                  style={{ display: 'none' }}
                  onChange={(e) => e.target.files[0] && handleLoadLasFile(e.target.files[0], lasFileCrs)}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>

      <DynamicModal
        isOpen={isPostgresqlModalVisible}
        onRequestClose={closePostgreSQLModal}
        title="PostgreSQL konekcija"
        mainContent={
          <PostgreSQLModalContent
            setHost={setHost}
            setPort={setPort}
            setDatabase={setDatabase}
            setUser={setUser}
            setPassword={setPassword}
          />
        }
        footerContent={
          <>
            <button
              type="button"
              className="app-btn app-btn-success"
              onClick={() => {
                readPostgreSQL();
                closePostgreSQLModal();
              }}
            >
              Poveži se
            </button>

            <button
              type="button"
              className="app-btn app-btn-secondary"
              onClick={closePostgreSQLModal}
            >
              Odustani
            </button>
          </>
        }
        customWidth="550px"
        customHeight="550px"
        centered={false}
        contentPadding="20px"
        bodyOverflowY="auto"
      />

      <DynamicModal
        isOpen={isPostgreSQLTableModalOpen}
        onRequestClose={closePostgreSQLTableModal}
        title={`Tabela: ${clickedTable}`}
        mainContent={
          <PostgreSQLTableModalContent
            host={host}
            port={port}
            database={database}
            user={user}
            password={password}
            table={clickedTable}
            setOverlay={setOverlay}
            setWfsLayers={setWfsLayers}
            setHoverInfo={setHoverInfo}
          />
        }
        footerContent={
          <button
            type="button"
            className="app-btn app-btn-secondary"
            onClick={closePostgreSQLTableModal}
          >
            Zatvori
          </button>
        }
        customWidth="90vw"
        customHeight="90vh"
        contentPadding="16px"
        bodyOverflowY="auto"
      />
    </>
  );
};

export default AddLayerSidebar;